<div class="flex w-full align-items-center justify-content-center">
	<i class="pi {{icon}} text-4xl mr-3"></i>
	<div class="flex flex-column justify-content-start">
		<div *ngIf="row1 !== ''">{{ row1 | translate }}</div>
		<div *ngIf="row2 !== ''">{{ row2 | translate }}</div>
	</div>
</div>
<div class="grid mt-3">
	<div class="col-12 flex justify-content-center gap-1">
		<button *ngIf="visibleAcceptButton" type="submit" pButton pRipple label="{{ labelAcceptButton | translate }}"
			[class]="classAcceptButton" (click)="submit()">
		</button>
		<button *ngIf="visibleRejectButton" type="button" pButton pRipple (click)="closeDialog();"
			label="{{ labelRejectButton | translate }}"
			[class]="classRejectButton">
		</button>
	</div>
</div>
